<script lang="ts" setup>
  import { usePlayerSession } from '../../model/playerSession.ts';
  import SpotifySignInView from './SpotifySignInView.vue';

  const { session, rejoinGame } = usePlayerSession({ asHost: true });

  const spotifySignIn = () => (window.location.href = '/api/spotify/redirect');
</script>

<template>
  <SpotifySignInView :session="session" @rejoin="rejoinGame" @spotify-sign-in="spotifySignIn" />
</template>
